import React, { useState, useEffect, SetStateAction, Dispatch, useMemo } from 'react';
import { connect, useDispatch, useIntl } from 'umi';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
import {
  createDetailIndexFetcher,
  createDetailIndexRankFetcher,
  createSingleGameDetailFetcher,
} from './services';
import {
  getVideosCommon,
  updateVideosPosterCommon,
  mergeCardRankData,
  transRankParams,
} from '@/pages/intelligence/utils/topchartsUtils';
import { swiperParamsInfo } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointGame } from '@/pages/home/utils/buriedPoint';
import { toOverviewDateType } from '@/pages/intelligence/utils/common';
import { isEmpty } from '@/pages/intelligence/utils/commonUtils';
// import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';
// import type { IGameType } from '@/pages/intelligence/types/common';
import AboutGameContent from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/AboutGameContent';
import { FILTER_EXTEND_NAMESPACE } from '@/pages/intelligence/models/filterExtend';
import Competitors from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/Competitors';
import SteamNewsAndAnnouncements from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/SteamNewsAndAnnouncements';
import { IReleaseDateByPlatformData } from '@intelligence/pages/TopCharts/MobileGames/components/GamesDetails/GameInfo/components/ReleaseDate';
import { COMBINEID_REG } from '@intelligence/utils/constant';

interface LooseObject {
  [key: string]: any;
}

// const PageLogMesMap: {
//   [key in IGameType]: any;
// } = {
//   mobile: dbiPageLogMes.mobileGameDetailsOverview,
//   pc: dbiPageLogMes.pcGameDetailsOverview,
//   console: dbiPageLogMes.consoleGameDetailsOverview,
//   [PC_CONSOLE_COMBINE_ENTITY_TYPE]: dbiPageLogMes.pcConsoleGameDetailsOverview,
// };

interface IGameInfo {
  appIdList: string[];
  gameId: string;
  entityType: string;
  isSingle: boolean;
  basicInfo: LooseObject;
  basicInfoOthers: LooseObject;
  activeId: string;
  moduleName: string;
  loading: boolean;
  setDetailIndex: Dispatch<SetStateAction<any>>;
  topchartsState: LooseObject;
  appIdListAll: string[];
  isCalibrated: boolean; // 切换 tabs 时没有使用状态，此时 isCalibrated 为 undefined，去本地里面做判断，所以 isCalibrated 是变量
  // releaseInFortyDay: boolean;
  gameDetails?: LooseObject | null;
}

const GameInfo: React.FC<IGameInfo> = (props) => {
  const {
    appIdList,
    gameId,
    entityType,
    isSingle,
    basicInfo,
    basicInfoOthers,
    activeId,
    // moduleName,
    loading: pLoading,
    setDetailIndex,
    topchartsState,
    appIdListAll,
    isCalibrated, // 切换 tabs 时没有使用状态，此时 isCalibrated 为 undefined，去本地里面做判断，所以 isCalibrated 是变量
    gameDetails,
  } = props;

  const { formatMessage } = useIntl(); // 中英切换方法

  const getDetailIndex = createDetailIndexFetcher(entityType);
  const getDetailIndexRank = createDetailIndexRankFetcher();
  const getSingleGameDetail = createSingleGameDetailFetcher(entityType);
  const getInitialParams = () => ({
    dateType: toOverviewDateType[entityType],
    regionType: 'region',
    regions: ['global'],
  });
  const dispatch = useDispatch();

  // 判断默认显示的数据源
  let source = '';
  if (isCalibrated) {
    source = 'databrain';
  } else if (isCalibrated === false) {
    source = 'appannie';
  } else {
    source = localStorage.getItem('initPlatform')
      ? localStorage.getItem('initPlatform') || 'appannie'
      : 'appannie';
  }

  // 把初始的数据源储存到本地做记录
  localStorage.setItem('initPlatform', source);

  const [dLoading, setDLoading] = useState(true);

  // about the game 数据
  const [videoScreen, setVideoScreen] = useState([]);
  const [seriesImages, setSeriesImages] = useState([]);
  const [seriesVideos, setSeriesVideos] = useState([]);
  const [seriesDesc, setSeriesDesc] = useState({});
  // competitors 数据
  const [similarGames, setSimilarGames] = useState([]);
  // related content 数据
  const [downloadContent, setDownloadContent] = useState<{
    [key: string]: any[];
  }>({});
  // release date by platform 数据
  const [releaseDateByPlatforms, setReleaseDateByPlatforms] = useState<
    IReleaseDateByPlatformData[]
  >([]);

  const [steamTags, gameModeTags, gameEngineTags, languageInfo] = useMemo(() => {
    const { game_mode: gameMode, steam_tag: steamTag, language } = basicInfo || {};
    const steamTags = steamTag ? steamTag.split('|') : [];
    const gameModeTags = gameMode ? gameMode.split('|') : [];

    // Get game_engine from gameDetails (detail_plus API) instead of basicInfo
    // game_engine from detail_plus API is an array of strings
    const gameEngineFromDetails = gameDetails?.game_engine;
    let gameEngineTags: string[] = [];
    if (Array.isArray(gameEngineFromDetails)) {
      gameEngineTags = gameEngineFromDetails.filter(Boolean);
    } else if (typeof gameEngineFromDetails === 'string' && gameEngineFromDetails.trim()) {
      gameEngineTags = gameEngineFromDetails.trim().split('|');
    }

    let languageInfo;
    try {
      languageInfo = JSON.parse(language);
    } catch (e) {
      console.error(e);
    }

    return [steamTags, gameModeTags, gameEngineTags, languageInfo];
  }, [basicInfo, gameDetails]);

  const getIndex = async (conditionMarket: any, conditionDate: any, isChangeRegion = false) => {
    const pcconsoleParamObj = {
      unified_id: gameId,
      entity_type: entityType,
      data_sources: [],
      date_type: conditionDate === '' ? toOverviewDateType[entityType] : conditionDate,
      is_first: topchartsState.isOverviewFirst,
      region_type: conditionMarket.regionType,
      regions: conditionMarket.regions,
      is_change_region: entityType === 'mobile' ? true : isChangeRegion,
      is_new_sytle: true,
    };
    const paramObj = pcconsoleParamObj;

    // 添加融合ID校验规则
    if (COMBINEID_REG.test(gameId)) {
      try {
        const cardRes = await getDetailIndex(paramObj);
        if (!isEmpty(cardRes)) {
          setDetailIndex(cardRes?.data);
          return {
            res: cardRes,
            paramObj,
          };
        }
        return {
          res: {},
          paramObj,
        };
      } catch (err) {
        return {
          res: {},
          paramObj,
        };
      }
    } else {
      return {
        res: {},
        paramObj,
      };
    }
  };

  const getPCConsoleRankData = async (list: any[], params: any, isChangeRegion = false) => {
    // 做接口参数兜底，防止报错
    const regions = params?.regions;
    const ranks = params?.rank_date_map;
    // 校验入参中 regions 不为空
    if (!Array.isArray(regions) || !regions?.length) return;
    // 校验入参中 rank_date_map 不为空
    if (!Array.isArray(ranks) || !ranks?.length) return;
    try {
      const paramsTemp = {
        ...params,
        is_change_region: entityType == 'mobile' ? true : isChangeRegion,
        is_new_sytle: true,
      };
      const resRank = await getDetailIndexRank(paramsTemp);
      const newList = mergeCardRankData(list, resRank?.data);
      /* 合并卡片和 Rank 内容后回填到卡片 */
      setDetailIndex([...newList]);
    } catch (e) {}
  };

  const getRankDataByEntityType = (list: any[], pcConsoleParams: any, isChangeRegion = false) => {
    getPCConsoleRankData(list, pcConsoleParams, isChangeRegion);
  };

  const getImageList = (images: any) => (images !== '' ? images?.split('|') : []);

  const swiperParams: swiperParamsInfo = {
    showArrows: true,
    showIndicators: false,
    infiniteLoop: true,
    autoPlay: false,
    emulateTouch: true,
    showStatus: false,
  };

  const allAppIds = () => {
    if (appIdListAll?.length !== 0) {
      return appIdListAll?.map((item: { id: any }) => item.id);
    }
    return [];
  };

  // 获取游戏系列 Similar Games 的数据
  const getSeriesGamesData = async (conditionMarketTpm: any, id = '') => {
    setDLoading(true);
    const result = await getSingleGameDetail({
      unified_id: gameId,
      app_id: id,
      app_ids: allAppIds(),
      entity_type: entityType,
      region_type: conditionMarketTpm.regionType,
      regions: conditionMarketTpm.regions,
      basic_info_others: basicInfoOthers,
    });

    const seriesVideos = getVideosCommon(result?.data?.video);
    updateVideosPosterCommon(seriesVideos, setSeriesVideos);
    setSeriesVideos(seriesVideos);
    setSeriesImages(getImageList(result?.data?.images || ''));
    // 获取视频截图
    const screenList = result?.data?.video_screen?.split('|');
    setVideoScreen(screenList || []);
    setSimilarGames(result?.data?.similar_games || []);
    const downloadableContents = result?.data?.download_content || {};
    const releaseDateByPlatforms = result?.data?.release_dates_by_platform || [];
    setDownloadContent(downloadableContents);
    setReleaseDateByPlatforms(releaseDateByPlatforms);
    setSeriesDesc({
      origin: result?.data?.description || '',
      en: result?.data?.description_en || '',
      zh: result?.data?.description_zh || '',
    });
    setDLoading(false);
  };

  const getData = async (
    conditionMarketTpm: any,
    conditionDateTpm: any,
    isChangeRegion = false,
  ) => {
    const { res, paramObj } = await getIndex(conditionMarketTpm, conditionDateTpm, isChangeRegion);

    const _list = res?.data;
    const rank_date_map = transRankParams(_list, res?.req?.date_type);
    const rankApiData = {
      ...paramObj,
      rank_date_map,
    };
    getRankDataByEntityType(_list, rankApiData, isChangeRegion);

    if (isSingle) {
      // 如果是直接进入单游戏详情页，要传游戏 id 过来
      getSeriesGamesData(
        conditionMarketTpm,
        Array.isArray(appIdList) && appIdList?.length > 0 ? appIdList[0] : '',
      );
    } else {
      getSeriesGamesData(conditionMarketTpm);
    }
  };

  useEffect(() => {
    if (pLoading) {
      setDLoading(true);
    } else {
      // 如果是从首页搜索进来，第一次 baseinfo 调用完，还没有获取卡片数据，就调用一次
      const initialParams = getInitialParams();
      const { dateType, regionType, regions } = initialParams ?? {};

      getData({ regionType, regions }, dateType);
      handlePageLog(gameId);
    }
  }, [pLoading]);

  const handlePageLog = (gameId: string) => {
    const pageLogMes = dbiPageLogMes.pcConsoleGameDetailsGameInfo;
    if (gameId) {
      buriedPointGame(pageLogMes, gameId);
    }
    // 每次打点的时候，记录当前打点信息用于详情页头部的 feedback 参数
    recordPageMesForFeedback(pageLogMes);
  };

  const recordPageMesForFeedback = (logMes: any) => {
    dispatch({
      type: `${DBI_TOPCHARTS}/setActivedPageLogMes`,
      payload: logMes,
    });
  };

  const hasSteamPlatform = basicInfo?.platform?.includes('steam');

  return (
    <div className="mobile-games-overly">
      <AboutGameContent
        isRelease={basicInfo?.is_release}
        platform={basicInfo?.platform}
        entityType={entityType}
        dLoading={dLoading}
        desc={seriesDesc}
        images={seriesImages}
        videos={seriesVideos}
        videoScreen={videoScreen}
        swiperParams={swiperParams}
        steamTags={steamTags}
        gameModeTags={gameModeTags}
        gameEngineTags={gameEngineTags}
        languageInfo={languageInfo}
        downloadContent={downloadContent}
        releaseDateByPlatforms={releaseDateByPlatforms}
      />

      <Competitors
        title={formatMessage({ id: 'dbi_competitors' })}
        gameName={basicInfo?.name}
        gameId={gameId}
        isRelease={basicInfo?.is_release}
        similarGames={similarGames}
        activeId={activeId}
        entityType={entityType}
        setDetailIndex={setDetailIndex}
        dLoading={dLoading}
      />

      {hasSteamPlatform && (
        <SteamNewsAndAnnouncements
          gameId={gameId}
          dLoading={dLoading}
          gameName={basicInfo?.name}
          steamID={basicInfo?.SteamID}
        />
      )}
    </div>
  );
};

export default connect((state: any) => ({
  filterState: state[FILTER_EXTEND_NAMESPACE],
  topchartsState: state[DBI_TOPCHARTS],
}))(GameInfo);
